import React from 'react';
import { runwayColors } from '../styles/globalStyles';
import Text from 'antd/lib/typography/Text';
import Link from 'antd/lib/typography/Link';

const DemoInstanceAnnouncementBanner: React.FC = () => {
    const announcementText = '✈️ Level up your mobile release management – Webinar, Sept 21st –';

    return (
        <div
            style={{
                backgroundColor: runwayColors.statusGreen,
                textAlign: 'center',
                paddingTop: 8,
                paddingBottom: 8,
                paddingLeft: 12,
                paddingRight: 12,
            }}
        >
            <Text style={{ color: 'white' }}>
                {announcementText}{' '}
                <Link
                    href="https://my.demio.com/ref/y88R0gHTt3Su6VLZ"
                    target="_blank"
                    style={{ color: 'white' }}
                    underline
                >
                    Register
                </Link>
            </Text>
        </div>
    );
};

export default DemoInstanceAnnouncementBanner;
